import { Button, Text } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import { coral } from 'theme/colors';
import { radius } from 'theme/radius';
import { shadows } from 'theme/shadows';

const KayakSearchButton = ({ goOpenKayakDialog }) => (
  <Button
    leftSection={<IconSearch size={20} color="white" />}
    size="lg"
    onClick={goOpenKayakDialog}
    style={{
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 8,
      paddingBottom: 8,
      borderRadius: radius.pill,
      backgroundColor: coral[6],
      color: 'white',
      boxShadow: shadows.card,
      textTransform: 'none'
    }}
    styles={{
      root: {
        '&:hover': {
          backgroundColor: coral[7],
          boxShadow: shadows.cardHover
        }
      }
    }}
  >
    <Text fw={600} size="md" c="white">
      Search
    </Text>
  </Button>
);

KayakSearchButton.propTypes = {
  goOpenKayakDialog: PropTypes.func.isRequired
};

export default KayakSearchButton;
